import { Observable, Subject } from 'rxjs';
import * as _ from 'underscore';

export class ReportWrapperService {
  private reportEvent:Subject<number> = new Subject<number>();
  private openedReports:number[] = [];

  constructor() {/***/
  }

  public loadReportData(reportId:number, force?:boolean):void {
    if (reportId) {
      const firstLoad:boolean = _.contains(this.openedReports, reportId); // this prevents reloading the report if that was already loaded (unless passing -> force=true)
      if (force || !(force || firstLoad)) {
        if (!firstLoad) {
          this.openedReports.push(reportId);
        }
        this.reportEvent.next(reportId);
      }
    }
  }

  public onLoadReportData():Observable<number> {
    return this.reportEvent.asObservable();
  }

  public clear():void {
    this.openedReports = [];
  }
}